import { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { api } from "../lib/api";
import { Header } from "../components/Header";
import { Footer } from "../components/Footer";

const KEY = "adv_token";
export const advSetToken = (t) => localStorage.setItem(KEY, t);
export const advGetToken = () => localStorage.getItem(KEY) || "";
export const advClearToken = () => localStorage.removeItem(KEY);

export default function AdvertiserLoginPage() {
  const nav = useNavigate();
  const [email, setEmail] = useState("");
  const [pw, setPw] = useState("");
  const [err, setErr] = useState("");
  const [notFound, setNotFound] = useState(false);

  useEffect(() => {
    document.title = "Advertiser Login — IslandsDaily";
    api.get("/advertise/enabled").then((r) => {
      if (!r.data?.enabled) setNotFound(true);
    }).catch(() => setNotFound(true));
  }, []);

  const submit = async () => {
    setErr("");
    try {
      const r = await api.post("/advertiser/login", { email, password: pw });
      advSetToken(r.data.token);
      nav("/advertiser/dashboard");
    } catch (e) {
      setErr(e?.response?.data?.detail || "Login failed");
    }
  };

  if (notFound) {
    return (
      <div className="min-h-screen bg-white flex items-center justify-center" data-testid="adv-login-404">
        <div className="text-center">
          <h1 className="font-serif-display text-3xl text-[#1A2E35]">404</h1>
          <Link to="/" className="text-[#0AADA0] mt-4 inline-block">← Home</Link>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-white" data-testid="advertiser-login-page">
      <Header />
      <main className="max-w-md mx-auto py-16 px-4">
        <h1 className="font-serif-display text-[#1A2E35] text-2xl mb-2">Advertiser Login</h1>
        <p className="text-[13px] text-[#6B7C82] mb-6">Manage your IslandsDaily campaigns.</p>
        <div className="space-y-3">
          <input
            type="email" placeholder="you@business.com" value={email}
            onChange={(e) => setEmail(e.target.value)}
            className="w-full border border-[#EEEEEE] rounded-lg px-3 py-2 text-sm"
            data-testid="adv-login-email"
          />
          <input
            type="password" placeholder="password" value={pw}
            onChange={(e) => setPw(e.target.value)}
            className="w-full border border-[#EEEEEE] rounded-lg px-3 py-2 text-sm"
            data-testid="adv-login-password"
          />
          {err && <p className="text-[12px] text-[#E63946]" data-testid="adv-login-error">{err}</p>}
          <button
            onClick={submit}
            className="w-full bg-[#0AADA0] text-white px-4 py-2 rounded-full text-[13px] font-medium"
            data-testid="adv-login-submit"
          >Login</button>
          <p className="text-[12px] text-[#6B7C82] text-center">
            Don't have an account yet? <Link to="/advertise" className="text-[#0AADA0]">Book your first ad →</Link>
          </p>
        </div>
      </main>
      <Footer />
    </div>
  );
}
